<template>
  <div v-show="(isShow && isShowTag)" class="item element"
  role="button"
  tabindex="0"
  draggable="true"
  @mouseenter="mouseEnter"
  @mouseleave="mouseLeave"
  @dragstart="dragStart"
  @touchstart="touchStart"
  @touchend="touchEnd"
  @touchmove="touchMove"
  @dragover="dragOver"
  @drop="drop"
  @dblclick="dblclick"
  @click="clickMobile"
  :data-dir="isDir"
  :aria-label="name"
  :aria-selected="isSelected">
   
    <div class="ibbCheckbox-wrapper" style="position: relative;" @mouseenter="mouseEnterCheck" @mouseleave="mouseLeaveCheck" @click="selectCheck">
      <input type="checkbox" id="checkbox" name="checkbox" v-model="selectItem">
      <img v-if="isSelected" src="/img/icons/other-stuff/ibbCheck.svg">
    </div>

    <div :id="name" class="icon">
      <img class="material-icons" :src="icon" draggable="false">
    </div>

    <div class="item-container">
      <div style="width: 100%; margin-left: 0;">
        <p v-if="type === 'snapshot'" :title="name" class="name">{{ snapshotName }}</p>
        <p v-else :title="name" class="name">{{ name }}</p>

        <div class="time-size">
          <p class="time"> {{ humanTime }}  </p>
        </div>

        <div class="tag-wrapped">
          <div v-if="type !== 'shared-drive' && !isBackup" class="tag">
            <p>{{ tagText }}</p>
          </div>
        </div>
        
        <button v-if="this.isMobile() && this.user.viewMode === 'mosaic'" @click="showMenu" @mouseenter="mouseEnterButton" @mouseleave="mouseLeaveButton">
          <more-horizontal-icon size="1.5x" class="custom-class"></more-horizontal-icon>
        </button>
      </div>
      <button v-if="this.isMobile() && this.user.viewMode === 'list'" @click="showMenu" @mouseenter="mouseEnterButton" @mouseleave="mouseLeaveButton">
        <more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { files as api } from '@/api';
import { MoreHorizontalIcon, MoreVerticalIcon } from 'vue-feather-icons';
import { ROUTES } from '@/router';

export default {
  name: 'item',
  data() {
    return {
      actionListener: null,
      timer: 0,
      isItem: false,
      isMultiSelected: false,
      isOptions: false,
      isSafari: false,
      isShow: true,
      selectItem: false,
      tagText: '',
      isShowTag: true,
      thumbnailURI: null,
    };
  },
  watch: {
    searchVal (val) {
      if (!this.name.toLowerCase().includes(val.toLowerCase())) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    filterTag (val) {
      if (val == this.tag || val == -1) {
        this.isShowTag = true;
      } else {
        this.isShowTag = false;
      }
    },
    selectItem (val) {
      if (val && !this.isSelected) {
        this.addSelected(this.index);
      } else if (!val && this.isSelected) {
        this.removeSelected(this.index);
      }
    },
    isSelected (val) {
      this.selectItem = val;
    },
  },
  components: {
    MoreHorizontalIcon,
    MoreVerticalIcon
  },
  props: ['name', 'isDir', 'url', 'type', 'size', 'modified', 'index', 'handle', 'nodeType', 'contact', 'ibbInstance', 'tag', 'synced'],
  computed: {
    ...mapState(['selected', 'req', 'isMenu', 'isPrompt', 'user', 'searchVal', 'isFaldon', 'filterTag', 'isMultiSelectedCheck']),
    ...mapGetters(['selectedCount', 'isBackup']),
    isSelected () {
      return (this.selected.indexOf(this.index) !== -1);
    },
    humanTime() {
      return moment(this.modified).format('DD/MM/YYYY');
    },
    snapshotName() {
      const matches = this.name.match(/^.*-\s(\d{4})_(\d{2})_(\d{2})\s(\d{2})_(\d{2})_(\d{2})$/);
      const date = new Date(+matches[1],+matches[2]-1,+matches[3], +matches[4],+matches[5],+matches[6]);
      return date.toLocaleString();
    },
    thumbnailName() {
      return '///thumbnails/' + this.handle;
    },
    icon () {
      if (this.isDir) 
      {  
          if (this.type === 'device')
          {
            return '/img/icons/WEBCLIENT_MimeTypes/ibbDevice.svg';
          } 
          else if (this.type === 'backup')
          {
            return '/img/icons/WEBCLIENT_MimeTypes/ibbBackup.svg';
          }
          else if (this.type === 'snapshot')
          {
            return '/img/icons/WEBCLIENT_MimeTypes/ibbCalendar.svg';
          }
          else if (this.type === 'inbox')
          {
            return '/img/icons/mimetype_inbox.png';
          }
          else if (this.type === 'record')
          {
            return '/img/icons/mimetype_record.png';
          }
          else if (this.type === 'shared-drive') {
            return '/img/icons/WEBCLIENT_MimeTypes/ibbSharedDrive.svg';
          }
          else
          {
            if (this.synced) {
              return '/img/icons/WEBCLIENT_MimeTypes/ibbSyncFolder.svg';
            }
            return '/img/icons/WEBCLIENT_MimeTypes/ibbFolder.svg';
          }
      }
      if (this.type === 'image') {
        return this.thumbnailURI || '/img/icons/WEBCLIENT_MimeTypes/ibbImage.svg';
      }
      if (this.type === 'audio') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbAudio.svg';
      }
      if (this.type === 'video') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbVideo.svg';
      } 
      if (this.type === 'txt') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbTxt.svg';
      } 
      if (this.type === 'pdf') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbPDF.svg';
      }
      if (this.type === 'zip') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbZIP.svg';
      }
      if (this.type === 'xls') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbXLS.svg';
      }
      if (this.type === 'doc') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbDoc.svg';
      }
      if (this.type === 'ppt') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbPPT.svg';
      }
      if (this.type === 'code') {
        return '/img/icons/WEBCLIENT_MimeTypes/ibbCode.svg';
      }
      return '/img/icons/WEBCLIENT_MimeTypes/ibbFile.svg';
    },
    canDrop () {
      if (!this.isDir) return false;

      for (let i of this.selected) {
        if (this.req.items[i].url === this.url) {
          return false;
        }
      }

      return true;
    }
  },
  async mounted() {
    if (window.navigator.vendor == 'Apple Computer, Inc.') {
      this.isSafari = true;
    }
    if (this.tag === Module.TagType.TAG_UNSET.value) {
      this.tagText = this.$t('tag.unset');
    } else if (this.tag === Module.TagType.TAG_PERSONAL.value) {
      this.tagText = this.$t('tag.personal');
    } else if (this.tag === Module.TagType.TAG_PUBLIC.value) {
      this.tagText = this.$t('tag.public');
    } else if (this.tag === Module.TagType.TAG_GENERAL.value) {
      this.tagText = this.$t('tag.general');
    } else if (this.tag === Module.TagType.TAG_CONFIDENTIAL.value) {
      this.tagText = this.$t('tag.confidential');
    } else if (this.tag === Module.TagType.TAG_HIGHLY_CONFIDENTIAL.value) {
      this.tagText = this.$t('tag.highConfidential');
    }

    if (this.filterTag == this.tag || this.filterTag == -1) {
      this.isShowTag = true;
    } else {
      this.isShowTag = false;
    }
    
    const sdk = (this.ibbInstance ? this.ibbInstance : ibb);
    if (this.type === 'image') {
      const uri = Module.getObjectURL(this.thumbnailName);
      if (uri) {
        this.thumbnailURI = uri;
      } else if (!window.gRequestedThumbnails.has(this.thumbnailName)) {
        window.gRequestedThumbnails.add(this.thumbnailName);
        const action = await sdk.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, this.thumbnailName);
        if (!action.error.type) {
          window.gRequestedThumbnails.delete(this.thumbnailName);
          const uri = Module.getObjectURL(this.thumbnailName);
          if (uri) {
            this.thumbnailURI = uri;
          }
        }
      }
    }

    const thisComponent = this;
    const JavaActionListenerClass = Module.ActionListener.extend('ActionListener', {
      onActionFinish(action) {
        if (action.type === Module.ActionType.UPLOAD_METADATA.value && action.nodeHandle == thisComponent.handle) {
          thisComponent.thumbnailURI = Module.getObjectURL(thisComponent.thumbnailName);
        }
      } 
    });
    this.actionListener = new JavaActionListenerClass();
    sdk.addActionListener(this.actionListener);
    document.addEventListener('click', this.clickEvent);
    document.addEventListener('contextmenu', this.contextMenu);
  },
  beforeDestroy () {
    const sdk = (this.ibbInstance ? this.ibbInstance : ibb);
    sdk.removeActionListener(this.actionListener);
    document.removeEventListener('click', this.clickEvent);
    document.removeEventListener('contextmenu', this.contextMenu);
  },
  methods: {
    ...mapMutations(['addSelected', 'removeSelected', 'resetSelected', 'setIsItemOptions', 'setIsMultiSelectedCheck']),
    showMenu() {
      this.$store.commit('showHover', 'item-options');
    },
    selectCheck(event) {
      event.stopPropagation();
    },
    clickMobile() {
      if (this.isMobile()) {
        if (this.selectedCount !== 0) {
          if (this.$store.state.selected.indexOf(this.index) !== -1 && !this.isMultiSelectedCheck) {
            this.removeSelected(this.index);
            return;
          }
          this.$store.commit('showHover', 'item-options');
          this.addSelected(this.index);
          return;
        } else if (!this.isOptions && this.selectedCount === 0) {
          this.open();
          return;
        } else if (this.isOptions && this.selectedCount === 0) {
          this.$store.commit('showHover', 'item-options');
          this.addSelected(this.index);
        }
      }
    },
    clickEvent(event) {
      if (!this.isMobile()) {
        this.setIsItemOptions(false);
        if (this.isItem) {
          if (!this.isSelected) {
            this.select(event);
            this.isMultiSelected = false;
            return;
          } else if (this.isSelected && (event.ctrlKey || event.metaKey)) {
            this.removeSelected(this.index);
          }
        } else {
          this.isMultiSelected = true;
          if (!event.ctrlKey && !event.metaKey) {
            if (this.isSelected && !this.isMenu && !this.isPrompt && !this.isFaldon && !this.isMultiSelectedCheck) {
              this.removeSelected(this.index);
              return;
            } 
          } 
        }
      } else {
        if (!this.isItem && this.isSelected && !this.isMenu && !this.isPrompt && !this.isFaldon && !this.isMultiSelectedCheck) {
          this.$store.commit('closeHovers');
          this.removeSelected(this.index);
        } 
      }
    },
    mouseEnter() {
      this.isItem = true;
    },
    mouseLeave() {
      this.isItem = false;
    },
    mouseEnterButton() {
      this.isOptions = true;
    },
    mouseLeaveButton() {
      this.isOptions = false;
    },
    mouseEnterCheck() {
      this.setIsMultiSelectedCheck(true);
    },
    mouseLeaveCheck() {
      this.setIsMultiSelectedCheck(false);
    },
    dragStart() {
      if (this.selectedCount === 0) {
        this.addSelected(this.index);
        return;
      }

      if (!this.isSelected) {
        this.resetSelected();
        this.addSelected(this.index);
      }
      else {
        this.resetSelected();
      }
    },
    dragOver: function (event) {
      if (!this.canDrop) return;

      event.preventDefault();
      let el = event.target;

      for (let i = 0; i < 5; i++) {
        if (!el.classList.contains('item')) {
          el = el.parentElement;
        }
      }

      el.style.opacity = 1;
    },
    drop: async function (event) {
      this.$emit('move-item');
      if (!this.canDrop) return;
      event.preventDefault();

      if (this.selectedCount === 0) return;

      let items = [];
      let isSharedDrive = false;

      for (let index of this.selected) {
        if (this.req.items[index].type !== Module.NodeType.SHARED_DRIVE_ROOT.value) {
          const {nodeList} = await ibb.getSortedChildren(this.req.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
          for (let item of nodeList) {
            if (item.name === this.req.items[index].name) {
              items.push({
                from: item.handle,
                to: this.handle
              });
            }
          }
        } else if (this.handle !== '') {
          await ibb.nestSharedDrive(this.req.items[index].handle, this.handle);
          isSharedDrive = true;
        } else {
          await ibb.unnestSharedDrive(this.req.items[index].handle);
          isSharedDrive = true;
        }
      }

      if (!isSharedDrive) {
        try {
          if (this.$route.name === ROUTES.DRIVE) {
            await api.moveId(items, ibbLink);
            let parentNode = await ibbLink.getNodeById(this.handle);
            if (parentNode.node.parentHandle === '') {
              this.$router.push({ path: this.$route.path + '#' + this.linkSharedDrive });
            } else {
              this.$router.push({ path: this.$route.path + '#' + this.handle });
            }
          } else {
            await api.moveId(items);
            this.$router.push({ path: this.$route.path + '#' + this.handle });
          }
        } catch (e) {
          this.$showError(this.$t('errors.movingNode'));
        }
      } else {
        this.$store.commit('resetSelected');
      }
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
    isIos: function() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    contextMenu(event) {
      if (!this.isMobile()) {
        if (this.selectedCount === 0) {
          this.isMultiSelected = false;
        } else if (this.selectedCount > 1) {
          this.isMultiSelected = true;
        }
        if (this.isItem) {
          this.$store.commit('showHover', 'item-options');
        }
        if (!this.isSelected && this.isItem) {
          this.select(event);
          return;
        } else if (!this.isItem && this.isSelected && !this.isMultiSelected) { 
          this.$store.commit('closeHovers');
          this.removeSelected(this.index);
          return;
        }
      } else {
        if (this.isItem && !this.isSelected) {
          this.select(event);
        } else if (!this.isItem && this.isSelected) {
          this.removeSelected(this.index);
        }
      }
    },
    dblclick() {
      if (!this.isMobile()) {
        this.open();
      }
    },
    select: function (event) {
      if (this.selectedCount !== 0) event.preventDefault();
      if (this.$store.state.selected.indexOf(this.index) !== -1) {
        this.removeSelected(this.index);
        return;
      }

      if (event.shiftKey && this.selected.length === 1) {
        let fi = 0;
        let la = 0;

        if (this.index > this.selected[0]) {
          fi = this.selected[0] + 1;
          la = this.index;
        } else {
          fi = this.index;
          la = this.selected[0] - 1;
        }

        for (; fi <= la; fi++) {       
          this.addSelected(fi);
        }

        return;
      }

      //if (!event.ctrlKey && !this.$store.state.multiple) this.resetSelected()
      if (!event.ctrlKey && !event.metaKey) {
        this.resetSelected();
      } 
      this.addSelected(this.index);
    },
    touchStart() {
      if (!this.isIos()) {
        return;
      }

      this.timer = setTimeout(() => {
        this.timer = 0;
        this.dragStart();
      }, 600);
    },
    touchEnd: function (event) {
      if (!this.isIos()) {
        return;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = 0;
      }
      else {
        event.preventDefault();
      }
    },
    touchMove() {
      if (!this.isIos()) {
        return;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = 0;
      }
    },
    open() { 
      if ((!this.isDir && this.size > 50*1024*1024) || (this.type === 'pdf' && this.isSafari))
      {
        api.downloadId(this.handle);
        this.$showSuccess(this.$t('transfers.downloadadded'));
        return;
      }
      this.$router.push({path: this.$route.path + '#' + this.handle});
    }
  }
};
</script>
